import {connect} from 'react-redux';
import UserCard from './UserCard';

const mapStateToProps = ({
                           user: {
                             user: {username, attributes}
                           }
                         }) => ({
  user: {
    ...attributes,
    username,
  }
});

export default connect(
  mapStateToProps,
  null
)(UserCard);
